<script>
import { useMainStore, useResponseStore, useEventStore } from '../../../stores/index';
import ProgressBarDocs from './ProgressBarResp.vue';
import Viwerjs from '../Modals/Viwerjs.vue';
import Editor from '@tinymce/tinymce-vue';
import RequiredFill from '../Modals/RequiredFill.vue';
import Cookie from 'js-cookie';
export default {
  name: 'DashboardDefault',
  components: { Editor, ProgressBarDocs, Viwerjs, RequiredFill },
  setup () {
    const StoreAll = useMainStore();
    const StoreRep = useResponseStore();
    const Events = useEventStore();
    return {
      Store: StoreAll,
      StoreResponse: StoreRep,
      Events
    };
  },
  data () {
    return {
      oldData: [],
      subject: '',
      editorContent: '',
      editorConfig: {
        min_height: 800,
        height: 800,
        max_height: 800,
        language: 'pt_BR',
        plugins: 'link image table quickbars',
        toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent  | advtablerownumbering | quickimage | fontsizeinput'
      },
      typeDoc: [{ id: 0, title: 'Selecione' }],
      typeSelect: 0,
      showDoc: false
    };
  },
  mounted () {
    this.GetTypes();
  },
  watch: {
  },
  methods: {
    async GetTypes () {
      const typesAPI = await this.Store.GetTypes();
      this.Types = typesAPI;
      if (this.StoreResponse.oldDoc.length >= 1) {
        this.oldData = this.StoreResponse.oldDoc[0];
      } else {
        this.oldData = this.StoreResponse.oldDoc;
      }
      /* verificar se isso funciona */

      this.StoreResponse.documentData.user_id = this.Store.user.id;
      this.StoreResponse.documentData.document_id = this.oldData.id;
      this.StoreResponse.documentData.typeDoc = this.oldData.document_type_id;

      const typeNone = this.Store.Types;
      if (!typeNone.some(obj => obj.id === 0)) {
        typeNone.push({ id: 0, title: 'Selecione' });
      }
      typeNone.sort((a, b) => a.id - b.id);
      this.typeDoc = typeNone;
      this.typeSelect = this.StoreResponse.documentData.typeDoc;

      if (this.StoreResponse.documentData.body) {
        this.editorContent = this.StoreResponse.documentData.body;
      } else {
        this.editorContent = (this.Store.user && this.Store.user.footer) ? this.Store.user.footer : '';
      }

      if (this.StoreResponse.documentData.subject === '') {
        if (this.subject === '') {
          this.subject = this.StoreResponse.oldDoc.subject;
        }
      } else {
        this.subject = this.StoreResponse.documentData.subject;
      }
    },

    isContentEmpty (content) {
      if (!content || typeof content !== 'string') {
        return true;
      }
      if (/<img|<table|<iframe|<svg/i.test(content)) {
        return false;
      }
      const clean = content
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
      return clean.length === 0;
    },

    nextProgress () {
      const hasValidType = this.typeSelect !== 0;
      const hasValidSubject = this.subject && this.subject.trim() !== '';
      const hasValidBody = !this.isContentEmpty(this.editorContent);

      if (!hasValidType || !hasValidSubject || !hasValidBody) {
        this.$refs.RequiredFill.openModal();
        return;
      }

      const data = {
        typeDoc: this.typeSelect,
        titleDoc: this.subject,
        contentDoc: this.editorContent
      };
      const CookieData = JSON.stringify(data);
      this.StoreResponse.documentData.subject = this.subject;
      this.StoreResponse.documentData.body = this.editorContent;
      Cookie.set('DataDocument', CookieData);
      this.StoreResponse.progress += 1;
    },

    backProgress () {
      this.Store.progress -= 1;
    }
  }
};
</script>
<style>
.box-model{
  width: 247px !important;
  height: 138px;
  border-radius: 8px;
  padding: 16px;
  gap: 8px;
  cursor: pointer;
}
.box-img{
  width: 56px;
  height: 56px;
  border-radius: 8px;
  padding: 16px;
  background-color: #E9ECEF;
}
.box-img-new{
  width: 56px;
  height: 56px;
  border-radius: 8px;
  padding: 16px;
  background-color: #ffffff;
}
@media screen and (max-width: 1450px) {
.box-model{
  width: 220px !important;
}
}

@media screen and (max-width: 1380px) {

.box-model{
  width: 200px !important;
}
}

@media screen and (max-width: 1200px) {
.box-model{
  width: 220px !important;
}
}

@media screen and (max-width: 1180px) {
  .box-model{
  width: 200px !important;
}
}

@media screen and (max-width: 1050px) {
  .box-model{
  width: 180px !important;
}
}
@media screen and (max-width: 992px) {
  .box-model{
  width: 150px !important;
}
}
@media screen and (max-width: 850px) {
  .box-model{
  width: 150px !important;
}
}
.tox {
  border-color: #CED4DA !important;
}
</style>
<template>
  <div class="container">
    <RequiredFill ref="RequiredFill" />
    <ProgressBarDocs />
    <div class="container mt-4">
      <div class="row">
        <h4 class="font-docs text-docs-black ml-1"><b>Dados do documento</b></h4>
      </div>

    <div class='row' style="margin-bottom: 3rem">
            <div class='mt-2'>
                <label class="label-docs text-docs-black">Titulo <span style="color: red;">*</span></label>
                <input class="my_form text-bold" @input="subject = subject.toUpperCase()" v-model="subject" placeholder="Ex: Ofício judicial" type="text">
            </div>
      </div>
      <hr>
      <div class="d-flex justify-content-between">
        <h4 class="font-docs text-docs-black ml-1 mt-3"><b>Despacho anterior</b></h4>
        <div style="cursor:pointer" @click="showDoc = !showDoc">
          <h4 v-show="showDoc" class="font-docs text-docs-black ml-1 mt-3"><b>Recolher -</b></h4>
          <h4 v-show="!showDoc" class="font-docs text-docs-black ml-1 mt-3"><b>Expandir +</b></h4>
        </div>
      </div>
      <div v-if="showDoc">
        <div v-show="!this.Store.mobile" style="height: 100vh">
            <iframe :src="this.Store.pdfNow" height="100%" width="100%"></iframe>
        </div>
        <div v-show="this.Store.mobile" style="height: 500px">
                <Viwerjs />
            </div>
      </div>
      <hr>
      <div v-for="docTitle in typeDoc" :key="docTitle" class="row">
        <h4 v-if="typeSelect === docTitle.id && typeSelect === 0" class="font-docs text-docs-black ml-1 mt-3"><b>Aguardando tipo *</b></h4>
        <h4 v-if="typeSelect === docTitle.id && typeSelect !== 0" class="font-docs text-docs-black ml-1 mt-3"><b>{{ docTitle.title }}</b></h4>
      </div>
      <div class='row mt-2'>
        <label class="label-docs text-docs-black">Corpo do documento <span style="color: red;">*</span> <img src="../../../assets/img/info.png" alt="" title="O preenchimento do corpo do documento é obrigatório"></label>
        <div>
          <Editor style='border: 2px solid;' v-model='editorContent'
                    api-key='lhbldb066rsly0ci0sul37fjp28wklje4c2nh83d9eyc6w9z' :init='editorConfig' />
      </div>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn mt-3 font-docs Color-Docs" style="border: 1px solid #F1860B" @click="backProgress()">Voltar</button>
          <button class="btn mt-3 ml-3 font-docs text-white background-Docs" @click="nextProgress()">Avançar</button>
        </div>
      </div>
  </div>

</template>
